import { Commit } from 'vuex';
import { RapportState } from '@/modules/Rapport/store/state';

export enum RapportActions{
    GET_RAPPORT = 'GET_RAPPORT',
    GET_RAPPORT_PDF = 'GET_RAPPORT_PDF',
    GET_ALL_RAPPORT_PDF = 'GET_ALL_RAPPORT_PDF'
}

export interface RapportActionTypes {
    commit: Commit;
    state: RapportState;
    getters: any;
}
